import { useMotionValue, useScroll, useTransform } from 'framer-motion';
import { ReactNode, useEffect, useRef } from 'react';
import { StickyTopBannerContent } from './_sticky_top_banner_content.component';

const SCROLL_THRESHOLD = [0, 40];

interface Props {
	children: ReactNode;
}

export function StickyTopBannerStickyScrollVariant({ children }: Props): JSX.Element {
	const { scrollY } = useScroll();
	const scrollYOnDirectionChange = useRef(scrollY.get());
	const lastPixelsScrolled = useRef<number>(0);
	const lastScrollDirection = useRef<'up' | 'down'>('down');
	const pixelsScrolled = useMotionValue(-40);
	const y = useTransform(pixelsScrolled, SCROLL_THRESHOLD, [0, -40]);

	useEffect(() => {
		return scrollY.onChange((latest) => {
			if (latest < 0) return;

			const isScrollingDown = scrollY.getPrevious() - latest < 0;
			const scrollDirection = isScrollingDown ? 'down' : 'up';
			const currentPixelsScrolled = pixelsScrolled.get();

			if (lastScrollDirection.current !== scrollDirection) {
				lastPixelsScrolled.current = currentPixelsScrolled;
				scrollYOnDirectionChange.current = latest;
			}

			let newPixelsScrolled: number;
			if (isScrollingDown) {
				newPixelsScrolled = Math.min(lastPixelsScrolled.current + (latest - scrollYOnDirectionChange.current), SCROLL_THRESHOLD[1]);
			} else {
				newPixelsScrolled = Math.max(lastPixelsScrolled.current - (scrollYOnDirectionChange.current - latest), SCROLL_THRESHOLD[0]);
			}

			pixelsScrolled.set(newPixelsScrolled);
			lastScrollDirection.current = scrollDirection;
		});
	}, [pixelsScrolled, scrollY]);

	return <StickyTopBannerContent style={{ y }}>{children}</StickyTopBannerContent>;
}
